import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetAllProjectsMembers(id) {
  return useQuery(['get-all-projects-members', id], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.PROJECT_MEMBERS_API, {
        project_id: id,
      })
    );
    return res.data;
  });
}
